module.exports = __webpack_public_path__ + "img/h_thumbnail.30ba37c5.png";